import React from 'react';
import { Input } from '@/components/ui/input';

const field = 'h-8 text-center text-sm px-1';

// Inline editor for one cricket side: runs / wickets (overs). Text inputs (no spinners) keep it narrow.
const SideRow = ({ label, side, inputs, setInputs, disabled, i, onEnter }) => {
  const set = (key) => (e) => setInputs((s) => ({ ...s, [`${key}_${side}`]: e.target.value }));
  const keys = { onKeyDown: (e) => { if (e.key === 'Enter') onEnter?.(); }, disabled };
  return (
    <div className="flex items-center gap-1" data-testid={`cricket-row-${side}-${i}`}>
      <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider w-10 truncate text-right" title={label}>{label}</span>
      <Input inputMode="numeric" placeholder="Runs" value={inputs[`score_${side}`]} onChange={set('score')} {...keys}
        className={`w-11 ${field}`} data-testid={`score-${side}-input-${i}`} aria-label={`${label} runs`} />
      <span className="text-slate-400">/</span>
      <Input inputMode="numeric" placeholder="Wkts" value={inputs[`wickets_${side}`]} onChange={set('wickets')} {...keys}
        className={`w-11 ${field}`} data-testid={`wickets-${side}-input-${i}`} aria-label={`${label} wickets`} />
      <Input inputMode="decimal" placeholder="Overs" value={inputs[`overs_${side}`]} onChange={set('overs')} {...keys}
        className={`w-12 ${field}`} data-testid={`overs-${side}-input-${i}`} aria-label={`${label} overs (optional)`} />
    </div>
  );
};

export const CricketScoreEditor = ({ match, inputs, setInputs, i, onEnter }) => (
  <div className="flex flex-col items-center gap-1" data-testid={`cricket-editor-${i}`}>
    <SideRow label={match.team_a_name || 'Team A'} side="a" inputs={inputs} setInputs={setInputs} disabled={!!match.forfeit_team} i={i} onEnter={onEnter} />
    <SideRow label={match.team_b_name || 'Team B'} side="b" inputs={inputs} setInputs={setInputs} disabled={!!match.forfeit_team} i={i} onEnter={onEnter} />
    <span className="text-[10px] text-slate-400">Runs / wickets · overs optional (e.g. 18.4)</span>
  </div>
);
